import { CustomerContactInfoType, CustomerInfoType, CustomerType } from "./types"

export const customerApi =
  process?.env?.REACT_APP_CUSTOMER_SERVICE_URL_DEFAULT ??
  "https://merchant-customer.izettletest.com"

export const customerBaseApi = (path: string) => `${customerApi}${path}`

// Paths

export const signUpPostPath = (orgUuid: string) =>
  `/public/organizations/${orgUuid}/customers`

export const sendReceiptToCustomerPath = (customerUuid: string, purchaseUuid: string) =>
  `/public/customers/${customerUuid}/purchases/${purchaseUuid}/send-receipt`

export const purchaseDetailGetPath = (orgUuid: string, purchaseUuid: string) =>
  `/public/organizations/${orgUuid}/purchases/${purchaseUuid}`

export const sellerInfoGetPath = (orgUuid: string) => `/public/seller/${orgUuid}`

export const removeCustomerfromSellerDeletePath = (
  orgUuid: string,
  customerUuid: string,
) => `/public/organizations/${orgUuid}/customers/${customerUuid}`

export const prepareSignUpBody = (purchaseUuid: string, customerInfo: CustomerInfoType) =>
  JSON.stringify({
    purchaseUuid,
    firstName: customerInfo.firstName,
    lastName: customerInfo.lastName,
    customerType: CustomerType.B2C,
    contactInfo: {
      email: customerInfo.email,
      phoneNumber: customerInfo.phone,
    },
  })

export const prepareContactInfoBody = ({ email, phone }: CustomerContactInfoType) =>
  JSON.stringify({
    email,
    phoneNumber: phone,
  })
